import React, { Component } from 'react';
import { UTILITY_USER_ROLE_ADMIN } from 'common/utility/userRoles';

import { SCREEN_ID_UTILITY_PROFIT_ADMIN_AUTOMATIC_ORDERS_DETAILS } from 'client/constants/screenIds';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedUtilityRoles from 'client/helpers/allowedUtilityRoles';

import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import UPAdminAutomaticOrdersDetails from 'client/components/UPAdminAutomaticOrders/UPAdminAutomaticOrdersDetails';

@withTransitionHook
@allowedUtilityRoles({
  roles: [UTILITY_USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_UTILITY_PROFIT_ADMIN_AUTOMATIC_ORDERS_DETAILS)
@withScrollToTop
class UtilityProfitAutomaticOrdersPageDetails extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Automatic Orders Details | Utility Profit',
  });

  render() {
    const { match } = this.props;

    return (
      <SrPartnerPageV2
        navbarTitle="Automatic Orders Details"
        backUrl="/utility-profit/admin/automatic-orders"
        redirectToLastLocation={false}
        maxWidth="100%"
      >
        <UPAdminAutomaticOrdersDetails orderId={match.params.orderId} />
      </SrPartnerPageV2>
    );
  }
}

export default UtilityProfitAutomaticOrdersPageDetails;
